export const openIM = () => {
  const easemobim = window.easemobim || {}
  easemobim.bind({
    configId: '2bac5aae-9fa6-40cd-b422-7c75e0d968f4',
    visitor: {
      trueName: '',
      userNickname: '',
      description: ''
    }
  })
}
